<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch7">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch7.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-7">“You’re on!” Connor growls. “But you go last.” Then he plugs in two more sets of controls.</a></p><a id="pg-7">
<p class="para" style="text-indent: 5%;">“Hey, what are you doing?” you cry.</p>
<p class="para" style="text-indent: 5%;">“These are for Nick and Debbie,” he replies.</p>
<p class="para" style="text-indent: 5%;">“No fair!” you protest. “I said I’d play against <em class="italic">you</em>.”</p>
<p class="para" style="text-indent: 5%;">“It’s all of us or no deal,” Connor snarls.</p>
<p class="para" style="text-indent: 5%;">What can you say? You nod and sigh. “Sure. Okay.”</p>
<p class="para" style="text-indent: 5%;">“Nick plays first,” Connor announces. “And remember — you have to beat <em class="italic">all</em> of us to win!”</p>
<p class="para" style="text-indent: 5%;">Nick begins to play. You’re not too worried, though. You’ve seen Debbie play. She couldn’t even handle level one. How good could Nick be?</p>
<p class="para" style="text-indent: 5%;">Nick makes his first moves. Uh-oh. Nick is excellent.</p>
<p class="para" style="text-indent: 5%;">Connor and Debbie bomb out early. But you and Nick move quickly through the lower levels. Finally, you both reach level twelve — the top level! You’ve never reached this level before.</p>
<p class="para" style="text-indent: 5%;">Beads of sweat trickle down your face. Up, down, jump! Right, left, shoot! You operate the controls like a pro.</p>
<p class="para" style="text-indent: 5%;">But then the Mud Monsters throw out a tidal wave of mud.</p>
<p class="para" style="text-indent: 5%;">Do you jump the wave or try to duck under it?</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-7"><em class="italic">Quick! Make a decision! To jump the wave, leap to </em></a><span href="#/e9780545841030_ch020" title="Link target outside of Sample"><em class="italic">PAGE 20</em></span>.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">To duck under, slide over to <span href="#/e9780545841030_ch072" title="Link target outside of Sample"><em class="italic">PAGE 72</em></span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch007.vue?6fbdfcfb